import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminAIContentStudio from "@/pages/admin/AdminAIContentStudio";

export const Route = createFileRoute("/admin/ai-content-studio")({
  component: () => (
    <ProtectedRoute>
      <AdminAIContentStudio />
    </ProtectedRoute>
  ),
});
